
import Vue from 'vue'

export default Vue.extend({
  props: {
    fields: {
      type: Array,
      required: true,
      default() {
        return []
      }
    },
    name: {
      type: String,
      required: true,
      default: ''
    },
    humanName: {
      type: String,
      required: true,
      default: ''
    },
    isCollapsed: {
      type: Boolean,
      default: false
    },
    extras: {
      type: Object,
      required: false,
      default() {
        return {}
      }
    }
  }
})
